import type { FC, HTMLAttributes, ReactNode } from 'react';
import { memo } from 'react';
import { twMerge } from 'tailwind-merge';

import { GraphModal } from '../../components/GraphModal/GraphModal';
import { clearYakli } from '../../redux/slices/yakli-slice';
import type { YakliDiscussionProps } from './YakliDiscussion';
import { YakliDiscussion } from './YakliDiscussion';

interface YakliDiscussionModalProps extends YakliDiscussionProps, HTMLAttributes<HTMLDivElement> {
  poper: ReactNode;
}

export const YakliDiscussionModal: FC<YakliDiscussionModalProps> = memo(
  function YakliDiscussionModal({ poper, className, slug, messageId, ...otherProps }) {
    return (
      <div className={twMerge('YakliDiscussionModal', className)} {...otherProps}>
        <GraphModal
          lazyContent={() => <YakliDiscussion slug={slug} messageId={messageId} isModalDisplay />}
          showPageOverlay
          forceModal
          contentClassName="max-w-[790px]"
          onHide={clearYakli}
        >
          {poper}
        </GraphModal>
      </div>
    );
  },
);
